import styled from "styled-components";

interface LabelsProps {
  margin?: React.CSSProperties["margin"];
  textAlign?: React.CSSProperties["textAlign"];
}

export const TitleLabel = styled.p`
  color: var(--color-primary);
  font-family: "Montserrat";
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  text-align: center;
`;

export const HeaderLabel = styled.p<LabelsProps>`
  color: var(--color-text-primary);
  font-family: "Montserrat";
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  text-align: ${(props) => props.textAlign || "center"};
  margin: ${(props) => props.margin || null};
`;

export const SubHeaderLabel = styled.p<LabelsProps>`
  color: var(--color-text-primary);
  font-family: "Montserrat";
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: ${(props) => props.textAlign || "center"};
`;

export const ForgotLabel = styled.p`
  color: var(--color-text-primary);
  font-family: "Montserrat";
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  &:hover {
    cursor: pointer;
  }
`;

export const HelpLabel = styled.p`
  color: var(--color-text-secondary);
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`;

export const GreenLabel = styled.p<LabelsProps>`
  color: var(--color-primary);
  font-family: "Inter";
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: ${(props) => props.textAlign || "center"};
  margin: ${(props) => props.margin || "0 0 16px 0"};
  &:hover {
    cursor: pointer;
  }
  svg {
    margin-right: 0.5rem;
  }
`;

export const ButtonText = styled.p`
  color: var(--color-text-secondary);
  font-family: "Inter";
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  margin: 2px 0 0 0;
`;

export const ProjectDetailsLabelBold = styled.p<LabelsProps>`
  color: var(--color-text-primary);
  font-family: "Montserrat";
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: ${(props) => props.textAlign || "left"};
  margin: ${(props) => props.margin || null};
`;

export const ProjectDetailsLabel = styled.p<LabelsProps>`
  color: var(--color-text-secondary);
  font-family: "Montserrat";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: ${(props) => props.textAlign || "left"};
`;

export const ProjectDetailsTitle = styled.p`
  color: var(--color-text-primary);
  font-family: "Montserrat";
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
`;

export const DownloadLink = styled.a<LabelsProps>`
  font-family: "Montserrat";
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: ${(props) => props.textAlign || "center"};
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`;

export const InvalidText = styled.p`
  color: var(--color-invalid);
  text-align: center;
`;

export const TermsText = styled.p`
  white-space: pre-line;
  font-family: "Montserrat";
  color: var(--color-text-secondary);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: justify;
`;
